import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import type { UiSettingsFormValue } from './uiSettings';

const ROWS: { key: keyof UiSettingsFormValue; label: string; description: string }[] = [
    {
        key: 'hideInbox',
        label: 'Hide inbox',
        description: 'Removes Inbox from the menu, search, and dashboard.',
    },
    {
        key: 'hideActions',
        label: 'Hide actions',
        description: 'Removes Actions from the menu and search.',
    },
    {
        key: 'hideSubmissions',
        label: 'Hide submissions',
        description: 'Removes Submissions from the menu, search, and dashboard.',
    },
];

export function UiSettingsFields({
    idPrefix,
    value,
    onChange,
    disabled,
}: {
    idPrefix: string;
    value: UiSettingsFormValue;
    onChange: (next: UiSettingsFormValue) => void;
    disabled?: boolean;
}) {
    return (
        <div className="space-y-4">
            {ROWS.map((row) => (
                <div key={row.key} className="flex items-center justify-between gap-4">
                    <div className="min-w-0">
                        <Label htmlFor={`${idPrefix}-${row.key}`}>{row.label}</Label>
                        <p className="text-xs text-gray-500 dark:text-gray-400">{row.description}</p>
                    </div>
                    <Switch
                        id={`${idPrefix}-${row.key}`}
                        checked={value[row.key]}
                        onCheckedChange={(checked) => onChange({ ...value, [row.key]: checked === true })}
                        disabled={disabled}
                    />
                </div>
            ))}
        </div>
    );
}
